import { ref, shallowRef, onMounted } from 'vue'
import { get } from '../../../utils/index'
/***
 * 处理表单（中部）
 */
export function useForm({
  formItemsUrl,
  formItems,
  formItemsCode,
  formUrl,
  formParam,
  updateBottomData,
}) {
  const formRef = ref(null)
  const formData = ref({})
  const formConfig = shallowRef({})

  const getform = async () => {
    if (formItems) {
      return formItems
    } else if (formItemsCode) {
      const [res] = await get(`${formItemsUrl}${formItemsCode}`)
      return res.data ?? {}
    } else {
      return null
    }
  }
  const getFormItems = async () => {
    const items = await getform()
    const tempItems = Array.isArray(items) ? { items } : items
    formConfig.value = tempItems
      ? {
          ...tempItems,
          form: {
            ...tempItems?.form,
            property: {
              colNum: 6, //number，一行展示多少列, 如: 5
              formGroup: false, //Boolean, 是否根据配置的formGroup组件进行分组
              ...tempItems?.form?.property,
            },
          },
        }
      : null
  }

  //更新表单数据
  const updateFormData = (data) => {
    if (data && data.hasOwnProperty('items')) {
      updateBottomData(data.items ?? [])
      data.items = undefined
    }
    formData.value = data
  }

  //初始获取表单数据
  const getInitFormData = async () => {
    if (!formUrl) {
      updateFormData({})
    } else {
      const [res] = await get(formUrl, formParam)
      updateFormData(res?.data ?? {})
    }
  }

  onMounted(() => {
    Promise.all([getFormItems(), getInitFormData()])
  })

  return {
    formRef,
    formData,
    formConfig,
    updateFormData,
    getInitFormData,
  }
}
